import { USER_PATH, USERS_GROUPS_PATH } from "./endpoints";

export const getGroups = async() => {
    const url = `${USERS_GROUPS_PATH}`;

    const requestOptions = {
        method: "GET"
    };

    const response = await fetch(url, requestOptions);
    const data = await response.json();

    if (!response.ok) {
        const error = data || response.statusText;
        return Promise.reject(error);
    }

    return data;
}

export const getGroupMembers = async(groupId) => {
    const url = `${USERS_GROUPS_PATH}/${groupId}`;

    const requestOptions = {
        method: "GET"
    };

    const response = await fetch(url, requestOptions);
    const data = await response.json();

    if (!response.ok) {
        const error = data || response.statusText;
        return Promise.reject(error);
    }

    return data;
}

export const addToken = async(body) => {
    const url = `${USER_PATH}/token`;
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(body)
    };

    const response = await fetch(url, requestOptions);
    const data = await response.json();

    if (!response.ok) {
        const error = data || response.statusText;
        return Promise.reject(error);
    }

    return data;
}

export const deleteToken = async(body) => {
    const url = `${USER_PATH}/token`;
    const requestOptions = {
        method: "DELETE",
        body: JSON.stringify(body)
    };

    const response = await fetch(url, requestOptions);
    const data = await response.json();

    if (!response.ok) {
        const error = data || response.statusText;
        return Promise.reject(error);
    }

    return data;
}

export const deleteGroup = async(id) => {
    const url = `${USERS_GROUPS_PATH}/${id}`;
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify({id})
    };

    const response = await fetch(url, requestOptions);
    const data = await response.json();

    if (!response.ok) {
        const error = data || response.statusText;
        return Promise.reject(error);
    }

    return data;
}

export const getSalesDashboard = async (personId) => {
    // TODO: pasar a sdk para obtener la url correspondiente
    
    let url = process.env.REACT_APP_ENV === 'v3' 
    ? 'https://urok6c24u7.execute-api.us-east-1.amazonaws.com/production'
    : 'https://q80i0bir9k.execute-api.us-east-1.amazonaws.com/devel'
    
    url+= `/sales_dashboard/${personId}`

    const requestOptions = {
        method: "GET",
        headers: {
            'x-api-key': process.env.REACT_APP_ENV === 'v3' ?'i4LXAe03w9e3b1z3TcQ4':'jH5NUcum5X0apUuccYNF',
            'Content-Type': 'application/json'
        }
    };

    const response = await fetch(url, requestOptions);
    const data = await response.json();

    if (!response.ok) {
        const error = data || response.statusText;
        return Promise.reject(error);
    }

    return data;
}